function getFingerprint() {
  const stored = localStorage.getItem('blog_fingerprint')
  if (stored) return stored

  const canvas = document.createElement('canvas')
  const ctx = canvas.getContext('2d')
  ctx.textBaseline = 'top'
  ctx.font = '14px Arial'
  ctx.fillText('fingerprint', 2, 2)

  const components = [
    navigator.userAgent,
    navigator.language,
    screen.colorDepth,
    screen.width + 'x' + screen.height,
    new Date().getTimezoneOffset(),
    !!window.sessionStorage,
    !!window.localStorage,
    canvas.toDataURL()
  ]

  let hash = 0
  const str = components.join('###')
  for (let i = 0; i < str.length; i++) {
    hash = ((hash << 5) - hash) + str.charCodeAt(i)
    hash |= 0
  }

  const fingerprint = 'fp_' + Math.abs(hash).toString(16)
  localStorage.setItem('blog_fingerprint', fingerprint)
  return fingerprint
}

export default getFingerprint
